import request from '@/utils/request'
export function fetchList(params) {
  return request({
    url:'/students/list',
    method:'get',
    params:params
  })
}
export function fetchListLess() {
  return request({
    url:'/students/list-less',
    method:'get'
  })
}
export function updateStatus(id,params) {
  return request({
    url:'/students/update/status/'+id,
    method:'post',
    params:params
  })
}
export function deleteStudent(id) {
  return request({
    url:'/students/delete/'+id,
    method:'delete'
  })
}
export function createStudent(data) {
  return request({
    url:'/students/create',
    method:'post',
    data:data
  })
}

export function updateStudent(data) {
  return request({
    url:'/students/update',
    method:'post',
    data:data
  })
}



// WEBPACK FOOTER //
// ./src/api/student.js